<template>
  <div>
    <div class="form-container ou-donation-form jlic-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Support Us">
            <AmountSelector />
            <ErrorLabel field="amount" />
            <TransactionFee />
          </FormSection>
          <FormSection title="Donation Frequency:">
            <div class="frequency">
              <PaymentOptions addSplit addMonthly monthlyText="Monthly" />
            </div>
          </FormSection>          
          <FormSection title="Your Details">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://teachcoalition.org/privacy-policy/"/>
                  </FormRow>               
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donate" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup() {
    const { setValue, form } = usePaymentForm();

    return {
      form
    };
  },
});
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}

.jlic-donation-form ::v-deep {
    margin: 0px auto;
    padding: 0px;
    box-shadow: none;
  h2 {
    color:#0D1823;
/* Desktop/Headline/H4 */
font-size: 20px;
font-style: normal;
font-weight: 700;
line-height: 24px; /* 120% */
letter-spacing: -0.2px;
    display: block;
    width: 100%;
    padding: 0;
    margin-bottom: 16px;
    text-transform: none;
    font-family: inherit;
    @media (min-width: 720px) {
    }

    &::before {
      content: none;
    }
  }

  .ou-donation-btn{
    background: var(--primary-default, #202558);
  }
  .styled-radio-container.styled-radio-container--ou-donation.row {

    .radio-part{
      @media (min-width: 720px) {
    min-width: 30%;
    flex: 1;
    padding-right: 10px;
    padding-left: 0;
    max-width: 30%;
    margin-bottom: 10px;
      }
    }
    label {
      // background: #aaa;
      color: white;
      color: #202558;
      width: 100%;
      font-size: 16px;
      font-style: normal;
      padding: 7px 15px;
      font-weight: 500;
      line-height: 24px;
      text-align: center;
      border-radius: 4px;
      border: 1.2px solid #202558;
      &:hover {
        background: rgba(32, 37, 88, 0.10);
      }
    }

    input[type="radio"]:checked + label {
        border-radius: 4px;
        border: 1.2px solid #202558;
        background: rgba(32, 37, 88, 0.10);
        color: #202558;
text-align: center;
font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
    }
    // input[type="radio"]:checked + label .label-amount {
    //   background: #0d346c;
    //   border-color: #0d346c;
    // }
  }
  .styled-radio.styled-radio--ou-donation.row {
    label {
      // background: #aaa;
      color: white;
      color: #202558;
      width: 100%;
      font-size: 16px;
      font-style: normal;
      padding: 9px 15px;
      font-weight: 500;
      line-height: 24px;
      text-align: center;
      border-radius: 4px;
      border: 1.2px solid #202558;
      &:hover {
        background: rgba(32, 37, 88, 0.10);
      }
    }

    input[type="radio"]:checked + label {
        border-radius: 4px;
        border: 1.2px solid #202558;
        background: rgba(32, 37, 88, 0.10);
        color: #202558;
text-align: center;
font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
    }
    // input[type="radio"]:checked + label .label-amount {
    //   background: #0d346c;
    //   border-color: #0d346c;
    // }
  }
}
</style>
